// Core
import React from 'react';
import graphColours from 'constants/graphColours';
import { useSelector } from 'react-redux';
// Components
import { GeckoRow } from 'ui';
import { Chart } from 'react-google-charts';
import StatsLoader from '../../../components/StatsLoader/index.jsx';

// Other

const maxChannels = 5;

const ConversationsByChannel = (props) => {
  let channels = [];
  const conversations = useSelector(
    (state) => state.statsRoute.conversationsByChannel
  );
  const fetchingStats = useSelector(
    (state) => state.statsRoute.fetchingConversationsByChannelStats
  );

  if (conversations.length) {
    conversations.forEach((channel, index) => {
      // Combine channel conversation totals if higher than maxChannels for displaying.
      if (index > maxChannels) {
        channels[maxChannels] = [
          'Other',
          channels[maxChannels][1] + channel.conversation_total,
        ];
      } else {
        channels.push([channel.channel_name, channel.conversation_total]);
      }
    });
  }

  const header = channels.length
    ? ['Channels', 'Conversations']
    : ['Channels', 'Conversations'];
  const graphData = channels.length
    ? [header, ...channels]
    : [
        ['Channels', 'Conversations'],
        ['No Conversations', 0],
      ];

  let options = {
    hAxis: { 
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, fontSize: 13, color: '#172554' },
      title: 'Channel Name', 
      minValue: 0, 
      slantedText: true,
      gridlines: {
        color: '#CBD5E1',
      },
      baselineColor: '#CBD5E1',
    },
    vAxis: {
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, fontSize: 13, color: '#172554' },
      title: 'Conversations',
      format: '#,###',
      minValue: 0,
      maxValue: 4,
      gridlines: {
        color: '#CBD5E1',
        count: -1
      },
      baselineColor: '#CBD5E1',
    },
    isStacked: false,
    legend: 'none',
    tooltip: { isHtml: true },
    focusTarget: 'category',
    colors: [graphColours.primary],
  };

  return (
    <div>
      <GeckoRow>
        <div className="col">
          <StatsLoader isLoading={fetchingStats}>
            <Chart
              chartType="ColumnChart"
              data={graphData}
              options={options}
              graph_id={props.id}
              width="100%"
              height="400px"
            />
          </StatsLoader>
        </div>
      </GeckoRow>
    </div>
  );
};

export default ConversationsByChannel;
